/* eslint-disable react/prop-types */
import React from "react";
import Loader from "./Loader";

const VARIANT_CLASS_MAP = {
  "glass-primary": "btn-glass-primary",
  "glass-secondary": "btn-glass-secondary",
  "glass-ghost": "btn-glass-ghost",
};

const Button = ({
  btnText,
  lineTwo,
  bgColor = "bg-secondary",
  textColor = "text-primary",
  onClick,
  type,
  disabled,
  starticon,
  endicon,
  paddingX = "",
  paddingY = "9px ",
  border = "1px",
  boldText = "font-bold",
  color,
  text,
  width,
  minWidth,
  borderradius = "1px",
  breakpoint,
  transparentbutton,
  hoverEffect = false,
  variant,
  pill = false,
}) => {
  const variantClass = variant ? VARIANT_CLASS_MAP[variant] : null;
  const isGlass = Boolean(variantClass);

  return (
    <button
      className={`${isGlass ? `${variantClass}${pill ? " btn-glass-pill" : ""} flex-center tracking-widest ${breakpoint || ""} ${width || ""}` : ""}
      ${!isGlass ? `${text ? text : text}  ${color ? color : bgColor} ${bgColor}  ${textColor}  border-[1px]  flex-center tracking-widest   hover:opacity-85 b-secondary ${width} ${breakpoint}   min-h-11 *:` : ""}
      ${!isGlass && hoverEffect ? "transition-all duration-200 hover:-translate-y-[1px] hover:shadow-[0_8px_18px_rgba(0,0,0,0.12)] active:translate-y-0" : ""}
      ${!isGlass && transparentbutton ? "#F5F5F7" : ""}
      `}
      disabled={disabled}
      onClick={onClick}
      type={type}
      color={color}
      style={
        isGlass
          ? {
              paddingBlock: paddingY,
              paddingInline: paddingX || undefined,
            }
          : {
              paddingBlock: paddingY,
              paddingInline: paddingX,
              borderRadius: borderradius,
              background: bgColor && bgColor.startsWith('#') ? bgColor : undefined,
              backgroundColor: bgColor && bgColor.startsWith('#') ? bgColor : undefined,
              color: textColor && textColor.startsWith('#') ? textColor : undefined,
              border: '2px solid #fff',
              boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)',
              fontWeight: 700,
            }
      }
    >
      {starticon ? <img src={starticon} className="mr-4 4xll:w-18 4xll:h-18 4xl:w-12 4xl:h-12 3xll:w-10 3xll:h-10 3xl:w-8 3xl:h-8 2xll:w-6 2xll:h-6 2xl:w-4 2xl:h-4" alt="" /> : ""}
      <div
        className={`flex-center gap-2 4xll:text-56 4xl:text-34 3xll:text-32  3xl:text-28 2xll:text-26 2xl:text-22 xl:text-20 lg:text-18 md:text-16  sm:text-16 xs:text-16 text-14 4xll:py-4 4xl:py-4 3xll:py-6  3xl:py-5 2xll:py-4 2xl:py-3  
  ${boldText} `}
      >
        {btnText} <br />
         {lineTwo}
      </div>
      {endicon ? (
        <img
          src={endicon}
          className="ml-6 4xll:size-9 4xl:size-8 3xll:size-7  3xl:size-6 2xll:size-5 2xl:size-4 "
          alt=""
        />
      ) : (
        ""
      )}
    </button>
  );
};

export default Button;
